export const zodEnum = <T>(arr: T[]) => {
  if (arr.length === 0) throw new Error("Empty array passed to zodEnum");
  return arr as [T, ...T[]];
};
